export default __webpack_public_path__ + "static/media/utp6.3793019a.jpg";